
import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase';


const sendFirebaseEvent = (title: string, category: string, action: string, label: any) => {
    try {
        if (analytics) {
            logEvent(analytics, title, {
                category,
                action,
                label: label ? label.toString() : '',
            });
        }
    } catch (e) {
        console.warn('Firebase analytics logEvent error:', e);
    }
}


export default sendFirebaseEvent;
